import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Link from "./Link";
import OpenNewIcon from "../Svg/Icons/OpenNew";
var LinkExternal = function(_param) {
    var _iconShow = _param.iconShow, iconShow = _iconShow === void 0 ? false : _iconShow, children = _param.children, _showIcon = _param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon, props = _object_without_properties(_param, [
        "iconShow",
        "children",
        "showIcon"
    ]);
    return /*#__PURE__*/ _jsxs(Link, _object_spread_props(_object_spread({
        external: true
    }, props), {
        children: [
            iconShow ? /*#__PURE__*/ _jsx("img", {
                src: "/images/small-img/icon6.png",
                width: 18,
                alt: "",
                style: {
                    marginRight: "6px"
                }
            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
            children,
            showIcon ? /*#__PURE__*/ _jsx(OpenNewIcon, {
                color: props.color ? props.color : "primary",
                ml: "4px"
            }) : /*#__PURE__*/ _jsx(_Fragment, {})
        ]
    }));
};
export default LinkExternal;
